import React from "react";
import PubSub from "./PubSub";

export const actions = new PubSub();
const ActionsContext = React.createContext(actions);

export default ActionsContext;